// AI Step 4: Initial Risk Assessment
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../../../components/ui/card';
import { Button } from '../../../../components/ui/button';
import { Alert, AlertDescription, AlertTitle } from '../../../../components/ui/alert';
import { AlertTriangle, Gauge, FileWarning, ExternalLink } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { RiskSliders, DualDimensionResult } from './RiskHelpers';

export default function Step4InitialRisk({ formData, updateField, calculateRisk, calculating, riskConfig }) {
  const navigate = useNavigate();

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold">Initial Risk Assessment</h2>
        <p className="text-muted-foreground mt-1">Assess AI risk using NIST AI RMF + Data Protection dimensions.</p>
      </div>
      <Card>
        <CardHeader className="pb-3">
          <CardTitle className="text-base flex items-center gap-2">
            <AlertTriangle className="h-4 w-4 text-amber-500" />Risk Variables (8 Factors)
          </CardTitle>
          <CardDescription>Adjust sliders based on your assessment of the AI system</CardDescription>
        </CardHeader>
        <CardContent>
          <RiskSliders riskType="initial" formData={formData} updateField={updateField} riskConfig={riskConfig} />
          <div className="mt-6 pt-4 border-t">
            <Button onClick={() => calculateRisk('initial')} disabled={calculating} data-testid="calculate-initial-risk">
              <Gauge className="h-4 w-4 mr-2" />{calculating ? 'Calculating...' : 'Calculate Initial Risk'}
            </Button>
          </div>
          <DualDimensionResult riskType="initial" formData={formData} />
          {formData.dpia_recommended && (
            <Alert className="mt-4 border-red-200 bg-red-50 dark:bg-red-950/20">
              <FileWarning className="h-4 w-4 text-red-600" />
              <AlertTitle className="text-red-700 dark:text-red-400">DPIA Recommended</AlertTitle>
              <AlertDescription className="text-red-600 dark:text-red-300">
                {formData.dpia_trigger_reason}
                <Button variant="link" className="p-0 h-auto ml-2 text-red-700" onClick={() => navigate('/risk/dpia/new')}>
                  Create DPIA <ExternalLink className="h-3 w-3 ml-1" />
                </Button>
              </AlertDescription>
            </Alert>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
